import { render, staticRenderFns } from "./clientsob.vue?vue&type=template&id=759ff932"
import script from "./clientsob.vue?vue&type=script&lang=js"
export * from "./clientsob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports